(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-quote-toggle]')) return;
    const form = document.querySelector('[data-quote-form]');
    if (form) {
      form.classList.add('is-open');
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  document.querySelectorAll('.cart-page__items quantity-stepper').forEach((stepper) => {
    const input = stepper.querySelector('[data-qty-input]');
    const submit = () => { const f = document.getElementById('cart-page-form'); if (f) f.submit(); };
    stepper.querySelector('[data-qty-minus]')?.addEventListener('click', () => { input.value = Math.max(0, (+input.value || 0) - 1); submit(); });
    stepper.querySelector('[data-qty-plus]')?.addEventListener('click', () => { input.value = (+input.value || 0) + 1; submit(); });
  });

  document.querySelectorAll('.cart-page__items [data-cart-remove]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('[data-cart-item]');
      const input = item?.querySelector('[data-qty-input]');
      if (input) { input.value = 0; document.getElementById('cart-page-form')?.submit(); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
  class CollectionShowcase extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.scrollByCard(-1));
      if (next) next.addEventListener('click', () => this.scrollByCard(1));
    }
    scrollByCard(dir) {
      if (!this.track) return;
      const card = this.track.querySelector('.showcase__card');
      const step = card ? card.getBoundingClientRect().width + 20 : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: step * dir, behavior: 'smooth' });
    }
  }
  customElements.define('collection-showcase', CollectionShowcase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs   = Array.from(this.querySelectorAll('[data-tab-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
      this.tabs.forEach(tab => tab.addEventListener('click', () => this.activate(tab)));
    }

    activate(activeTab) {
      const target = activeTab.dataset.tabTrigger;
      this.tabs.forEach(tab => {
        const on = tab === activeTab;
        tab.classList.toggle('coltabs__tab--active', on);
        tab.setAttribute('aria-selected', on);
      });
      this.panels.forEach(panel => {
        panel.hidden = panel.dataset.tabPanel !== target;
      });
    }
  }
  customElements.define('collection-tabs', CollectionTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-shop"] && !Shopify.designMode) return;
  try {
    
  class FeaturedShelf extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.scrollByCard(-1));
      if (next) next.addEventListener('click', () => this.scrollByCard(1));
    }
    scrollByCard(dir) {
      if (!this.track) return;
      const card = this.track.querySelector('.ftshelf__item');
      const step = card ? (card.getBoundingClientRect().width + 16) * 2 : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: step * dir, behavior: 'smooth' });
    }
  }
  if (!customElements.get('featured-shelf')) {
    customElements.define('featured-shelf', FeaturedShelf);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale"] && !Shopify.designMode) return;
  try {
    
  class FlashSale extends HTMLElement {
    connectedCallback() {
      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.setupCountdown();
      this.setupCopy();
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    setupCountdown() {
      const dateStr = this.dataset.end;
      const timeStr = this.dataset.time || '23:59';
      if (!dateStr) {
        // Tarih yoksa sabit 12 saatlik döngü göster (demo/fallback)
        this.fallback = true;
        this.remaining = 12 * 3600;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
        return;
      }
      this.target = new Date(dateStr + 'T' + timeStr + ':00').getTime();
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    tick() {
      let diff;
      if (this.fallback) {
        diff = this.remaining;
        this.remaining = this.remaining > 0 ? this.remaining - 1 : 12 * 3600;
      } else {
        diff = Math.floor((this.target - Date.now()) / 1000);
        if (diff <= 0) {
          diff = 0;
          if (this.timer) clearInterval(this.timer);
        }
      }
      const d = Math.floor(diff / 86400);
      const h = Math.floor((diff % 86400) / 3600);
      const m = Math.floor((diff % 3600) / 60);
      const s = diff % 60;
      const pad = (n) => String(n).padStart(2, '0');
      if (this.daysEl) this.daysEl.textContent = pad(d);
      if (this.hoursEl) this.hoursEl.textContent = pad(h);
      if (this.minutesEl) this.minutesEl.textContent = pad(m);
      if (this.secondsEl) this.secondsEl.textContent = pad(s);
    }

    setupCopy() {
      const btn = this.querySelector('.flash-sale__code');
      if (!btn) return;
      const label = btn.querySelector('[data-code-label]');
      btn.addEventListener('click', async () => {
        const code = btn.dataset.code;
        try {
          await navigator.clipboard.writeText(code);
        } catch (e) {
          const ta = document.createElement('textarea');
          ta.value = code;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (err) {}
          document.body.removeChild(ta);
        }
        const original = label.textContent;
        btn.classList.add('is-copied');
        label.textContent = btn.dataset.labelCopied;
        setTimeout(() => {
          btn.classList.remove('is-copied');
          label.textContent = original;
        }, 1800);
      });
    }
  }
  customElements.define('flash-sale', FlashSale);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.setupMegaMenu();
      this.setupDrawer();
    }

    setupMegaMenu() {
      this.openItem = null;
      const items = this.querySelectorAll('.mega-nav__item--has-panel');
      items.forEach((item) => {
        const trigger = item.querySelector('[data-mega-trigger]');
        const panel = item.querySelector('[data-mega-panel]');
        if (!trigger || !panel) return;

        const open = () => {
          if (this.openItem && this.openItem !== item) this.closeItem(this.openItem);
          panel.hidden = false;
          item.setAttribute('data-open', '');
          trigger.setAttribute('aria-expanded', 'true');
          this.openItem = item;
        };
        item._close = () => {
          panel.hidden = true;
          item.removeAttribute('data-open');
          trigger.setAttribute('aria-expanded', 'false');
        };

        trigger.addEventListener('click', () => {
          item.hasAttribute('data-open') ? this.closeItem(item) : open();
        });
        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', () => this.closeItem(item));
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.openItem) {
          const trigger = this.openItem.querySelector('[data-mega-trigger]');
          this.closeItem(this.openItem);
          if (trigger) trigger.focus();
        }
      });
      if (this.dataset.closeOutside !== 'false') {
        document.addEventListener('click', (e) => {
          if (this.openItem && !this.openItem.contains(e.target)) this.closeItem(this.openItem);
        });
      }
      this.addEventListener('focusout', (e) => {
        if (this.openItem && !this.openItem.contains(e.relatedTarget)) this.closeItem(this.openItem);
      });
    }

    closeItem(item) {
      if (item && item._close) item._close();
      if (this.openItem === item) this.openItem = null;
    }

    setupDrawer() {
      this.drawer = this.querySelector('[data-mobile-drawer]');
      this.openBtn = this.querySelector('[data-drawer-open]');
      if (!this.drawer || !this.openBtn) return;

      const open = () => {
        this.drawer.hidden = false;
        requestAnimationFrame(() => this.drawer.setAttribute('data-open', ''));
        this.openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        const firstFocusable = this.drawer.querySelector('.mobile-drawer__close');
        if (firstFocusable) firstFocusable.focus();
      };
      const close = () => {
        this.drawer.removeAttribute('data-open');
        this.openBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        setTimeout(() => { this.drawer.hidden = true; }, 300);
        this.openBtn.focus();
      };

      this.openBtn.addEventListener('click', open);
      this.drawer.querySelectorAll('[data-drawer-close]').forEach((el) => el.addEventListener('click', close));
      this.drawer.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    }
  }
  customElements.define('site-header', SiteHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
  class InstagramFeed extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-marquee] .igfeed__track');
      if (!track || track.dataset.cloned) return;
      // Sonsuz akış için kartları 2x kopyala
      track.innerHTML += track.innerHTML;
      track.dataset.cloned = 'true';
    }
  }
  customElements.define('instagram-feed', InstagramFeed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  class LookbookShop extends HTMLElement {
    connectedCallback() {
      this.addBtn = this.querySelector('[data-add-all]');
      this.querySelectorAll('.lookbook__product').forEach((card) => {
        const select = card.querySelector('[data-variant-select]');
        const hidden = card.querySelector('[data-variant-id]');
        if (select && hidden) {
          select.addEventListener('change', () => { hidden.value = select.value; });
        }
      });
      if (this.addBtn) this.addBtn.addEventListener('click', () => this.addAll());
    }
    addAll() {
      const ids = Array.from(this.querySelectorAll('[data-variant-id]'))
        .map((i) => i.value)
        .filter(Boolean);
      if (!ids.length) return;
      const items = ids.map((id) => ({ id: Number(id), quantity: 1 }));
      const original = this.addBtn.textContent;
      this.addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
        .then((r) => r.json())
        .then(() => {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          this.addBtn.textContent = this.addBtn.dataset.added || 'Sepete Eklendi';
          setTimeout(() => { this.addBtn.textContent = original; this.addBtn.disabled = false; }, 1800);
        })
        .catch(() => { this.addBtn.disabled = false; });
    }
  }
  customElements.define('lookbook-shop', LookbookShop);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'belnil_popup_hidden';
    var popup = document.getElementById('newsletter-popup');
    if (!popup || popup.dataset.enabled !== 'true') return;
    var showOn = popup.dataset.showOn || 'both';
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    if (showOn === 'desktop' && isMobile) return;
    if (showOn === 'mobile' && !isMobile) return;
    var delay = parseInt(popup.dataset.delay, 10) || 0;
    var days  = parseInt(popup.dataset.days, 10) || 30;

    function isHidden() {
      try { return !!localStorage.getItem(KEY); } catch(e) { return false; }
    }
    function setHidden() {
      try {
        localStorage.setItem(KEY, Date.now() + days * 864e5);
      } catch(e) {}
    }
    function clearExpired() {
      try {
        var exp = localStorage.getItem(KEY);
        if (exp && Date.now() > Number(exp)) localStorage.removeItem(KEY);
      } catch(e) {}
    }

    function open() {
      popup.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      popup.hidden = true;
      document.documentElement.style.overflow = '';
      setHidden();
    }

    clearExpired();
    if (!isHidden()) {
      setTimeout(open, Math.max(0, delay));
    }

    popup.querySelectorAll('[data-popup-close]').forEach(function(el) {
      el.addEventListener('click', close);
    });
    popup.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') close();
    });

    if (popup.dataset.success === 'true') {
      var wrap    = popup.querySelector('[data-form-state]');
      var formEl  = popup.querySelector('form');
      var success = popup.querySelector('.popup-dialog__success');
      if (formEl)  formEl.hidden = true;
      if (success) success.hidden = false;
      setHidden();
      setTimeout(close, 3000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const observer = new IntersectionObserver((entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        this.load();
      }, { rootMargin: '0px 0px 400px 0px' });
      observer.observe(this);
    }
    async load() {
      try {
        const res = await fetch(this.dataset.url);
        const text = await res.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const fresh = html.querySelector('product-recommendations');
        if (fresh && fresh.innerHTML.trim().length) {
          this.innerHTML = fresh.innerHTML;
        }
      } catch (e) { console.error('Recommendations failed', e); }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.scrollByCard(-1));
      if (next) next.addEventListener('click', () => this.scrollByCard(1));
    }
    scrollByCard(dir) {
      if (!this.track) return;
      const card = this.track.querySelector('.reviews__card');
      const step = card ? card.getBoundingClientRect().width + 20 : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: step * dir, behavior: 'smooth' });
    }
  }
  customElements.define('reviews-carousel', ReviewsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class SlideShow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slideshow-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slideshow-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-slideshow-dot]'));
      this.prevBtn = this.querySelector('[data-slideshow-prev]');
      this.nextBtn = this.querySelector('[data-slideshow-next]');
      this.counterCurrent = this.querySelector('[data-slideshow-counter-current]');
      this.index = 0;

      this.prevBtn?.addEventListener('click', () => { this.go(this.index - 1); this.restartAutoplay(); });
      this.nextBtn?.addEventListener('click', () => { this.go(this.index + 1); this.restartAutoplay(); });
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.restartAutoplay(); }));

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { this.go(this.index - 1); this.restartAutoplay(); }
        if (e.key === 'ArrowRight') { this.go(this.index + 1); this.restartAutoplay(); }
      });

      this.autoplayEnabled = this.dataset.autoplay === 'true' && this.dataset.reduceMotion !== 'true' && this.slides.length > 1;
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 5000;
      if (this.autoplayEnabled) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
      }

      this.update();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    go(i) {
      const len = this.slides.length;
      this.index = (i + len) % len;
      this.update();
    }

    update() {
      this.style.setProperty('--slideshow-index', this.index);
      this.slides.forEach((slide, i) => {
        slide.toggleAttribute('inert', i !== this.index);
        slide.classList.toggle('is-active', i === this.index);
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
      if (this.counterCurrent) this.counterCurrent.textContent = this.index + 1;
    }

    startAutoplay() {
      if (!this.autoplayEnabled) return;
      this.stopAutoplay();
      this.timer = setInterval(() => this.go(this.index + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
    }

    restartAutoplay() {
      if (this.autoplayEnabled) this.startAutoplay();
    }
  }
  customElements.define('slide-show', SlideShow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-banner"] && !Shopify.designMode) return;
  try {
    
  class SplitBanner extends HTMLElement {
    connectedCallback() {
      this.tabs   = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panels]'));
      this.tabs.forEach(tab => tab.addEventListener('click', () => this.activate(tab.dataset.tab)));
    }
    activate(index) {
      this.tabs.forEach(tab => tab.classList.toggle('is-active', tab.dataset.tab === index));
      this.panels.forEach(p => p.classList.toggle('is-active', p.dataset.panels === index));
    }
  }
  customElements.define('split-banner', SplitBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const animate = (el) => {
      const target = parseInt(el.dataset.countTo, 10);
      if (isNaN(target)) return;
      const dur = 1400; const start = performance.now();
      const step = (now) => {
        const p = Math.min((now - start) / dur, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased).toLocaleString('tr-TR');
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { animate(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('.stat__number[data-count-to]').forEach((el) => io.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsCarousel extends HTMLElement {
    connectedCallback() {
      this.slides  = Array.from(this.querySelectorAll('[data-slide]'));
      this.visuals = Array.from(this.querySelectorAll('[data-visual]'));
      this.current = this.querySelector('[data-current]');
      this.index = 0;
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.go(-1));
      if (next) next.addEventListener('click', () => this.go(1));
    }
    go(dir) {
      if (this.slides.length < 2) return;
      this.slides[this.index]?.classList.remove('is-active');
      this.visuals[this.index]?.classList.remove('is-active');
      this.index = (this.index + dir + this.slides.length) % this.slides.length;
      this.slides[this.index]?.classList.add('is-active');
      this.visuals[this.index]?.classList.add('is-active');
      if (this.current) this.current.textContent = this.index + 1;
    }
  }
  customElements.define('testimonials-carousel', TestimonialsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-top-bar-track]').forEach(function (track) {
      track.innerHTML += track.innerHTML;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
